export class APIError extends Error {
  public abort?: boolean;
  public status?: number;
  public type?: string;
  public details?: string[];

  constructor(args: { response?: Response; abort?: boolean; type?: string; details?: string[] }) {
    super(args.type || "");

    this.abort = args.abort;
    this.status = args.response?.status;
    this.type = args.type;
    this.details = args.details;

    Object.defineProperty(this, "name", {
      configurable: true,
      enumerable: false,
      value: "APIError",
      writable: true,
    });

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, APIError);
    }
  }
}
